import { EntityApprovalStatus, entityApprovalStatus } from '@/api/entity/types';
import { FundApprovalStatus, fundApprovalStatus } from '@/api/fund/types';

/**
 * A Fund's own approval statuses that make it suspended.
 * (Re-verification Pending / Rejected / Blocked.)
 */
const SUSPENDED_FUND_STATUSES: FundApprovalStatus[] = [
  fundApprovalStatus.ReVerificationPending,
  fundApprovalStatus.Rejected,
  fundApprovalStatus.Blocked,
];

/**
 * Parent-entity statuses that suspend every linked Fund — the entity is
 * pending (awaiting approval / re-verification) or closed (blocked / rejected).
 */
const SUSPENDED_ENTITY_STATUSES: EntityApprovalStatus[] = [
  entityApprovalStatus.AwaitingApproval,
  entityApprovalStatus.ReVerificationPending,
  entityApprovalStatus.Blocked,
  entityApprovalStatus.Rejected,
];

export const isEntitySuspended = (status?: EntityApprovalStatus | null): boolean =>
  !!status && SUSPENDED_ENTITY_STATUSES.includes(status);

/**
 * A Fund is suspended when its own status is suspended OR its parent entity is.
 * Suspended Funds are hidden from public/Browse pages and unavailable for
 * investment; existing investors keep portfolio access.
 */
export const isFundSuspended = (
  fundStatus?: FundApprovalStatus | null,
  entityStatus?: EntityApprovalStatus | null,
): boolean =>
  (!!fundStatus && SUSPENDED_FUND_STATUSES.includes(fundStatus)) || isEntitySuspended(entityStatus);

export const FUND_SUSPENSION_TOOLTIP =
  "This Fund is currently unavailable for investment. It's undergoing review by Gamma Prime and will resume accepting investments once approved.";
